import { SmsBlockType } from 'feature/auth/redux/authSlice'
import { useEffect } from 'react'
import { FC } from 'react'
import { useActions, useAppSelector } from 'store/hooks'

import style from './ReqCounter.module.scss'

interface IReqCounter {
  whenZero?: () => void
}

// счетчик для смс сообщений (для повторной отправки)
export const ReqCounter: FC<IReqCounter> = ({ whenZero }) => {
  const { smsInfo } = useAppSelector(state => state.auth)
  const { setSmsInfo } = useActions()

  useEffect(() => {
    const timer = setInterval(() => {
      if (smsInfo.blockTime > 0) {
        setSmsInfo({ blockTime: smsInfo.blockTime - 1 })
      }
      if (smsInfo.blockTime === 1) {
        clearInterval(timer)
        if (whenZero) whenZero()
        setSmsInfo({ blockType: null })
      }
    }, 1000)

    return () => clearInterval(timer)
  }, [smsInfo.blockTime])

  if (!smsInfo.blockTime) return <></>

  const minutes = Math.floor(smsInfo.blockTime / 60)
  const seconds = smsInfo.blockTime - minutes * 60

  if (smsInfo.blockType !== SmsBlockType.countLimit) return <></>

  return (
    <div className={style.timer}>
      <p>
        <span>Достигнут лимит отправки сообщений. Повторите попытку через</span>
        <span className={style.time}>
          {`${String(minutes).length === 1 ? `0${minutes}` : minutes}:${
            String(seconds).length === 1 ? `0${seconds}` : seconds
          }`}
        </span>
      </p>
    </div>
  )
}
